var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__Close_bright",
    width: 28.721,
    height: 28.721,
    "data-name": "Close bright",
    viewBox: "0 0 28.721 28.721",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-2{fill:none;stroke:#6f6f6f;stroke-linecap:round;stroke-width:2px}\n        "))), /*#__PURE__*/React.createElement("path", {
    id: "prefix__bg",
    d: "M14.36 0A14.36 14.36 0 1 1 0 14.36 14.36 14.36 0 0 1 14.36 0z",
    style: {
      fill: "#fff",
      opacity: 0.35
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__X"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__X-2",
    d: "M20.057 8.6L7.712 20.665",
    className: "prefix__cls-2",
    "data-name": "X",
    transform: "translate(.423 .073)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Pfad_9157",
    d: "M12.063 0L0 12.026",
    className: "prefix__cls-2",
    "data-name": "Pfad 9157",
    transform: "rotate(-90 14.517 6.222)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.62ac252d.svg";
export { ForwardRef as ReactComponent };